import { RichText } from 'prismic-reactjs';

export function formatTitle(primary) {
  let formattedText = RichText.asText(primary.content_title);

  if (primary.underline_title) {
    formattedText = `<u>${formattedText}</u>`;
  }

  if (primary.title_colour) {
    formattedText = `<h1 style="color: ${primary.title_colour}">${formattedText}</h1>`;
  }

  return `<h1>${formattedText}</h1>`;
}

export function formatSubTitle(item) {
  let formattedText = RichText.asText(item.sub_title);

  if (item.underline_sub_title) {
    formattedText = `<u>${formattedText}</u>`;
  }

  if (item.sub_title_colour) {
    formattedText = `<h2 style="color: ${item.sub_title_colour}">${formattedText}</h2>`;
  }

  return `<h2 style="margin-bottom: 0;">${formattedText}</h2>`;
}

export function formatText(text, spans, underlineParts, color, colorParts) {
  let formattedText = text;
  let offset = 0;

  // Handle bold and hyperlink spans
  spans?.forEach((span) => {
    const { start, end } = span;
    const startIndex = start + offset;
    const endIndex = end + offset;
    const spanText = formattedText.substring(startIndex, endIndex);

    let newSpanText = spanText;

    if (span.type === 'hyperlink') {
      const { url } = span.data;
      newSpanText = `<a href="${url}" target="_blank">${spanText}</a>`;
    } else if (span.type === 'strong') {
      newSpanText = `<strong>${spanText}</strong>`;
    }

    formattedText =
      formattedText.substring(0, startIndex) +
      newSpanText +
      formattedText.substring(endIndex);

    offset += newSpanText.length - spanText.length;
  });

  // Handle underlining parts of the text
  underlineParts?.forEach(({ text }) => {
    const regex = new RegExp(escapeRegExp(text), 'g');
    formattedText = formattedText.replace(regex, `<u>${text}</u>`);
  });

  // Handle coloring parts of the text
  colorParts?.forEach(({ text }) => {
    const regex = new RegExp(escapeRegExp(text), 'g');
    formattedText = formattedText.replace(
      regex,
      `<span style="color: ${color}">${text}</span>`,
    );
  });

  return formattedText;
}

export function formatListItems(items, underlineParts, color, colorParts) {
  let listItems = '';

  items.forEach((item) => {
    let formattedText = formatText(
      item.text,
      item.spans,
      underlineParts,
      color,
      colorParts,
    );
    listItems += `<li style="text-align: left;">${formattedText}</li>`;
  });

  if (listItems) {
    listItems = `<ul style="padding-left: 20px; list-style-position: outside; margin-top: 0;">${listItems}</ul>`;
  }

  return listItems;
}

export function formatOrderedListItems(
  items,
  underlineParts,
  color,
  colorParts,
) {
  let listItems = '';

  items.forEach((item) => {
    let formattedText = formatText(
      item.text,
      item.spans,
      underlineParts,
      color,
      colorParts,
    );
    listItems += `<li style="text-align: left;">${formattedText}</li>`;
  });

  if (listItems) {
    listItems = `<ol style="padding-left: 20px; list-style-position: outside;">${listItems}</ol>`;
  }

  return listItems;
}

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
